module.exports = __webpack_public_path__ + "img/icon_account.191ff45f.2694870b.svg";